// `video.audio`: a finished track laid under a finished video, live's `VIDEO_AUDIO` (spec
// G14-pixar-singing-ad), the worker's own ffmpeg. Live lists no such job; a template's run starts
// it.
import { VideoAudioQuote, VideoAudioRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"video.audio"> = {
  type: "video.audio",
  label: "Video audio",
  source: "form",
  pair: "video.audio",
  fields: () => ({}),
  request: VideoAudioRequest,
  quote: VideoAudioQuote,
};
